import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["role", "commission"]

  connect() {
    this.toggleCommission()
  }

  toggleCommission() {
    if (!this.hasRoleTarget || !this.hasCommissionTarget) return

    const isSalesRole = this.roleTarget.value === "sales"
    this.commissionTarget.hidden = !isSalesRole

    this.commissionTarget.querySelectorAll("input, select, textarea").forEach((input) => {
      input.disabled = !isSalesRole
    })
  }
}
